import { render, staticRenderFns } from "./BasketDeliveryType.vue?vue&type=template&id=47da23ed"
import script from "./BasketDeliveryType.vue?vue&type=script&lang=js"
export * from "./BasketDeliveryType.vue?vue&type=script&lang=js"
import style0 from "./BasketDeliveryType.vue?vue&type=style&index=0&id=47da23ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports